import React, { useState } from 'react'
import {
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
} from 'firebase/auth'
import { auth } from './firebaseConfig'

export default function LoginPage() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')

  const handleLogin = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError('')
    setMessage('')

    try {
      const userCred = await signInWithEmailAndPassword(auth, email, password)
      console.log('✅ Login berhasil:', userCred.user.email)

      // ❗ Tidak perlu onLoginSuccess — App.js otomatis mendeteksi login
    } catch (err) {
      console.error('❌ Error login:', err.code, err.message)
      
      if (err.code === 'auth/network-request-failed') {
        setError('Koneksi internet bermasalah. Periksa jaringan Anda.')
      } else if (err.code === 'auth/too-many-requests') {
        setError('Terlalu banyak percobaan gagal. Coba lagi nanti.')
      } else if (
        err.code === 'auth/invalid-credential' || 
        err.code === 'auth/wrong-password' || 
        err.code === 'auth/user-not-found'
      ) {
        setError('Email atau password salah.')
      } else {
        setError('Gagal login. Silakan coba lagi.')
      }
    } finally {
      setLoading(false)
    }
  }

  const handleForgotPassword = async () => {
    if (!email) {
      setError('Masukkan email terlebih dahulu.')
      return
    }

    setLoading(true) // Tambahan baru
    setError('')
    
    try {
      await sendPasswordResetEmail(auth, email)
      setMessage('📩 Email reset password telah dikirim!')
    } catch (err) {
      console.error('❌ Gagal kirim email reset:', err.code)
      if (err.code === 'auth/network-request-failed') {
        setError('Gagal mengirim karena masalah jaringan. Coba lagi.')
      } else {
        setError('Gagal mengirim email reset password.')
      }
    } finally {
      setLoading(false) // Tambahan baru
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 to-black">
      <div className="bg-gray-800 p-8 rounded-2xl shadow-2xl w-96 border border-gray-700">
        <h1 className="text-3xl font-bold text-center text-white mb-8">
          Zimo Admin Login
        </h1>

        <form onSubmit={handleLogin}>
          <div className="mb-4">
            <label className="block text-gray-300 mb-2 text-sm">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
              className="w-full p-2 bg-gray-700 border border-gray-600 rounded-lg text-white focus:ring-2 focus:ring-blue-500 focus:outline-none disabled:opacity-50"
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-300 mb-2 text-sm">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading}
              className="w-full p-2 bg-gray-700 border border-gray-600 rounded-lg text-white focus:ring-2 focus:ring-blue-500 focus:outline-none disabled:opacity-50"
            />
          </div>

          {error && (
            <p className="text-red-500 text-sm text-center mb-3">{error}</p>
          )}
          {message && (
            <p className="text-green-500 text-sm text-center mb-3">{message}</p>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 rounded-lg transition duration-200 mb-3 disabled:opacity-50 disabled:cursor-not-allowed flex justify-center items-center"
          >
            {loading ? (
              <>
                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Memproses...
              </>
            ) : (
              'Masuk'
            )}
          </button>

          <button
            type="button"
            onClick={handleForgotPassword}
            disabled={loading}
            className="w-full text-sm text-blue-400 hover:text-blue-300 mt-1 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Lupa password?
          </button>
        </form>
      </div>
    </div>
  )
}
